
const initState = {
  stylists: [
    {id: '1', firstName: 'Ashley', lastName: 'Simpson', schedule_id: 1, services: [1,2,3,4,5,6,7,8,9]},
    {id: '2', firstName: 'Megan', lastName: 'Anderson', schedule_id: 2, services: [1,4,7]}
  ],
  schedules: [
    {id: '1', stylist_id: 1, days: [1,2,3,4,5], startTime: '08:00:00', endTime: '16:00:00', startBreak: '14:00:00', endBreak: '14:30:00'},
    {id: '2', stylist_id: 2, days: [2,3,4,5,6], startTime: '14:00:00', endTime: '22:00:00', startBreak: '18:00:00', endBreak: '18:30:00'}
  ],
  services: [
    {id: 1, type: 'female', value: 'femaleHair', label: 'Haircut (30 min)', time: 30},
    {id: 2, type: 'female', value: 'femaleHairColor', label: 'Haircut + Color (80 min)', time: 80},
    {id: 3, type: 'female', value: 'femaleColor', label: 'Color Only (50 min)', time: 50},
    {id: 4, type: 'male', value: 'maleHair', label: 'Haircut (15 min)', time: 15},
    {id: 5, type: 'male', value: 'maleHairColor', label: 'Haircut + Color (30 min)', time: 30},
    {id: 6, type: 'male', value: 'maleColor', label: 'Color Only (15 min)', time: 15},
    {id: 7, type: 'kid', value: 'kidHair', label: 'Haircut (10 min)', time: 10},
    {id: 8, type: 'kid', value: 'kidHairColor', label: 'Haircut + Color (30 min)', time: 30},
    {id: 9, type: 'kid', value: 'kidColor', label: 'Color Only (15 min)', time: 15}
  ]
}

const stylistReducer = (state = initState, action) => {
  switch(action.type) {
    default:
      return state;
  }
}

export default stylistReducer
